<div class="footer-version">
  v{{ version }} {{ environment | uppercase }}
</div>
